import React from 'react';
import { MailIcon, InstagramIcon, MessagesSquareIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-white/5 bg-ink-950 px-5 py-12" data-id="element-82" data-mp="3gfiyquovsxjx">
      <div className="mx-auto flex w-full max-w-4xl flex-col items-center gap-6 text-center" data-id="element-83" data-mp="32o48c2sn9u2u">
        <div data-id="element-84" data-mp="36p6c8wxiaub5">
          <span className="font-display text-base font-bold tracking-tight text-white" data-id="element-85" data-mp="36oo8lf8ildt7">
            Capital Consciente
          </span>
          <p className="mt-2 max-w-md text-sm text-gray-500" data-id="element-86" data-mp="3ufjyu7xbo0yc">
            El camino de una mentoría privada, sin la barrera de entrada.
          </p>
        </div>

        <div className="flex items-center gap-3" data-id="element-87" data-mp="3lf58uv9exxoi">
          <a href="mailto:hola@capitalconsciente.com" aria-label="Enviar un mail" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-ink-900 text-gray-400 transition-colors hover:border-brand/40 hover:text-brand" data-id="element-88" data-mp="3lggaopjasvcz">
            <MailIcon className="h-4 w-4" data-id="element-89" data-mp="2ezbau1wdje64" />
          </a>
          <a href="#" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-ink-900 text-gray-400 transition-colors hover:border-brand/40 hover:text-brand" data-id="element-90" data-mp="3l9k4zam1djc8">
            <InstagramIcon className="h-4 w-4" data-id="element-91" data-mp="3v89dics1lrft" />
          </a>
          <a href="#" aria-label="Discord" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-ink-900 text-gray-400 transition-colors hover:border-brand/40 hover:text-brand" data-id="element-92" data-mp="3v5n74ggw1hz6">
            <MessagesSquareIcon className="h-4 w-4" data-id="element-93" data-mp="33xbprfttmpc" />
          </a>
        </div>

        <p className="text-xs text-gray-600" data-id="element-94" data-mp="31uotg9z09ou">
          © {new Date().getFullYear()} Capital Consciente. Este material es
          educativo y no constituye asesoramiento financiero.
        </p>
      </div>
    </footer>;
}